import formatters from "./formatters";
import _ from "lodash";

const helpers = {
    texts: {
        editionWarning: 'No se han guardado los datos ingresados aún y serán perdidos si no los guarda. ¿Desea continuar?'
    },
    groups: {
        SYSADMIN: 'Sysadmin',
        ADMINISTRATOR: 'Administrator',
        PROGRAMMER: 'Programmer',
        PROVIDER: 'Provider',
        INTERNAL_USER: 'Internal User',
        ISLAND_OPERATOR: 'Island Operator',
        RECEPTION: 'Reception',
        REPORT: 'Reports',
    },
    groupsFE: () => {
        let groups = helpers.groups;
        return [
            groups.SYSADMIN,
            groups.ADMINISTRATOR,
            groups.PROGRAMMER,
            groups.PROVIDER,
            groups.ISLAND_OPERATOR,
            groups.RECEPTION
        ]
    },
    groupsINTERNAL: () => {
        let groups = helpers.groups;
        return [
            groups.SYSADMIN,
            groups.ADMINISTRATOR,
            groups.INTERNAL_USER,
            groups.RECEPTION
        ]
    },
    groupsTranslated: () => {
        let groups = helpers.groups;
        return {
            [groups.SYSADMIN]: 'Administrador',
            [groups.ADMINISTRATOR]: 'Administrador',
            [groups.PROGRAMMER]: 'Programación',
            [groups.PROVIDER]: 'Proveedor',
            [groups.INTERNAL_USER]: 'Cargas Generales',
            [groups.ISLAND_OPERATOR]: 'Operador',
            [groups.RECEPTION]: 'Recepción',
            [groups.REPORT]: 'Reportes'
        }
    },
    trip_type: {
        FE: 'FE',
        INTERNAL: 'INTERN'
    },
    tripSteps: {
        FOB: [
            {name: 'Viaje Programado', code: 'initial'},
            {name: 'Despacho', code: 'dispatch'},
            {name: 'Ingreso a Terminal', code: 'entry'},
            {name: 'Control de Documentación', code: 'documentation'},
            {name: 'Descargas', code: 'discharge'},
            {name: 'Balanza Salida', code: 'exit'},
            {name: 'Egreso', code: 'done'}
        ],
        CIF: [
            {name: 'Despacho', code: 'initial'},
            {name: 'Ingreso a Terminal', code: 'entry'},
            {name: 'Control de Documentación', code: 'documentation'},
            {name: 'Descargas', code: 'discharge'},
            {name: 'Balanza Salida', code: 'exit'},
            {name: 'Egreso', code: 'done'}
        ],
        INTERNAL: [
            {name: 'Nuevo Viaje', code: 'initial'},
            {name: 'Control de Ingreso', code: 'entry'},
            {name: 'Control de Salida', code: 'exit'}
        ]
    },
    states: {
        canceled: ['E103', 'E104'],
        rejected: ['E5']
    },
    getUserHomes: (user) => {
        if (!user) {
            return {FE: false, INTERNAL: false};
        }

        let userGroups = user.groups.map(gr => gr.name);

        let FE = false;
        let INTERNAL = false;

        userGroups.forEach(group => {
            if (helpers.groupsFE().indexOf(group) > -1) FE = true;
            if (helpers.groupsINTERNAL().indexOf(group) > -1) INTERNAL = true;
        });

        return {FE, INTERNAL};
    },
    canUserCreateTrip: (user) => {
        if (!user) {
            return false;
        }

        let groups = helpers.groups;
        let userGroups = user.groups.map(gr => gr.name);

        // Providers, check group and Provider data
        if (userGroups.indexOf(groups.PROVIDER) > -1) {
            return (user.provider && user.provider.can_create_cif_trips);
        }

        // Sysadmins, Administrators and Programmers can create Trips (FOB)
        let canCreate = false;
        userGroups.forEach(group => {
            if ([groups.SYSADMIN, groups.PROGRAMMER, groups.RECEPTION, groups.ADMINISTRATOR].indexOf(group) > -1) {
                canCreate = true;
            }
        });

        return canCreate;
    },
    getUserCreateButtons: (user) => {
        if (!user) {
            return false;
        }

        let buttons = [];

        if(helpers.isUserProvider(user)){
            buttons = [{
                text: 'Nuevo Viaje CIF',
                url: 'CIF',
            }]
        }

        if(helpers.isUserProgrammer(user)){
            buttons = [{
                text: 'Nuevo Viaje',
                url: 'FOB'
            }]
        }


        if(helpers.isUserReception(user) || helpers.isUserAdmin(user)){
            buttons = [{
                text: 'Nuevo Viaje CIF',
                url: 'CIF'
            },{
                text: 'Nuevo Viaje FOB',
                url: 'FOB'
            }]
        }

        return buttons;
    },
    canUserCreateInternalTrip: (user) => {
        if (!user) {
            return false;
        }

        let groups = helpers.groups;
        let userGroups = user.groups.map(gr => gr.name);

        // Sysadmins, Administrators, Internal User & Reception can create Trips (FOB)
        let canCreate = false;
        userGroups.forEach(group => {
            if ([groups.SYSADMIN, groups.ADMINISTRATOR, groups.INTERNAL_USER, groups.RECEPTION].indexOf(group) > -1) {
                canCreate = true;
            }
        });

        return canCreate;
    },
    canUserDischarge: (user) => {
        if (!user) {
            return false;
        }

        let groups = helpers.groups;
        let userGroups = user.groups.map(gr => gr.name);

        // Sysadmins, Island Operators
        let canDischarge = false;
        userGroups.forEach(group => {
            if ([groups.SYSADMIN, groups.ISLAND_OPERATOR].indexOf(group) > -1) {
                canDischarge = true;
            }
        });

        return canDischarge;
    },
    canUserReject: (user) => {
        if (!user) {
            return false;
        }

        let groups = helpers.groups;
        let userGroups = user.groups.map(gr => gr.name);

        // Sysadmins, Island Operators
        let canReject = false;
        userGroups.forEach(group => {
            if ([groups.SYSADMIN, groups.ISLAND_OPERATOR, groups.ADMINISTRATOR].indexOf(group) > -1) {
                canReject = true;
            }
        });

        return canReject;
    },
    canUserCancel: (user) => {
        if (!user) {
            return false;
        }

        let groups = helpers.groups;
        let userGroups = user.groups.map(gr => gr.name);

        // Sysadmins, Island Operators
        let canCancel = false;
        userGroups.forEach(group => {
            if ([groups.SYSADMIN, groups.PROGRAMMER, groups.ADMINISTRATOR].indexOf(group) > -1) {
                canCancel = true;
            }
        });

        return canCancel;
    },
    canUserEditInternalTrip: (user) => {
        if (!user) {
            return false;
        }

        let groups = helpers.groups;
        let userGroups = user.groups.map(gr => gr.name);

        // Sysadmins, Island Operators
        let canEdit = false;
        userGroups.forEach(group => {
            if ([groups.SYSADMIN, groups.ADMINISTRATOR, groups.RECEPTION].indexOf(group) > -1) {
                canEdit = true;
            }
        });

        return canEdit;
    },
    canUserSeeReports: (user) => {
        if (!user) {
            return false;
        }

        let groups = helpers.groups;
        let userGroups = user.groups.map(gr => gr.name);

        // Sysadmins, Island Operators
        let canReport = false;
        userGroups.forEach(group => {
            if ([groups.SYSADMIN, groups.ADMINISTRATOR, groups.PROGRAMMER, groups.REPORT].indexOf(group) > -1) {
                canReport = true;
            }
        });

        return canReport;
    },
    canEditOpenTrip: (user) => {
        // For Admin, sysadmin, programmer, reception edit trips on 'A0'
        return (helpers.isUserProgrammer(user) || helpers.isUserReception(user) || helpers.isUserAdmin(user) || helpers.isUserSysadmin(user) )
    },
    canEditOpenTripOriginData: (user) => {
        // For Admin, sysadmin, programmer, reception & provider edit trips on 'B0'
        return (helpers.isUserProvider(user) || helpers.isUserProgrammer(user) || helpers.isUserAdmin(user) || helpers.isUserSysadmin(user) || helpers.isUserReception(user))
    },
    isUserProvider: (user) => {
        if (!user) {
            return false;
        }

        let userGroups = user.groups.map(gr => gr.name);

        // Providers, check group and Provider data
        if (userGroups.indexOf(helpers.groups.PROVIDER) > -1) {
            return (user.provider && user.provider.id);
        }
        return false;
    },
    isUserProgrammer: (user) => {
        if (!user) {
            return false;
        }

        let userGroups = user.groups.map(gr => gr.name);
        return userGroups.indexOf(helpers.groups.PROGRAMMER) > -1;
    },
    isUserReception: (user) => {
        if (!user) {
            return false;
        }

        let userGroups = user.groups.map(gr => gr.name);
        return userGroups.indexOf(helpers.groups.RECEPTION) > -1;
    },
    isUserReport: (user) => {
        if (!user) {
            return false;
        }

        let userGroups = user.groups.map(gr => gr.name);
        return userGroups.indexOf(helpers.groups.REPORT) > -1;
    },
    isUserAdmin: (user) => {
        if (!user) {
            return false;
        }

        let userGroups = user.groups.map(gr => gr.name);
        let groups = helpers.groups;
        let isAdmin = false;

        userGroups.forEach(group => {
            if ([groups.SYSADMIN, groups.ADMINISTRATOR].indexOf(group) > -1) {
                isAdmin = true;
            }
        });

        return isAdmin;

    },
    isUserSysadmin: (user) => {
        if (!user) {
            return false;
        }

        let userGroups = user.groups.map(gr => gr.name);
        let groups = helpers.groups;

        return (userGroups).indexOf(groups.SYSADMIN) > -1;
    },
    isUserOperator: (user) => {
        if (!user) {
            return false;
        }

        let userGroups = user.groups.map(gr => gr.name);
        let groups = helpers.groups;

        return (userGroups).indexOf(groups.ISLAND_OPERATOR) > -1;
    },
    getUserHomeColumns: (user, trip_type=null) => {

        if(trip_type === helpers.trip_type.INTERNAL){
            return [
                {
                    dataField: 'terminal__name',
                    text: 'Destino',
                    path: 'terminal.name',
                    sort: true
                },
                {
                    dataField: 'destination_area__name',
                    text: 'Area',
                    path: 'destination_area.name',
                    sort: true
                },
                {
                    dataField: 'operation_type',
                    text: 'Operación',
                    path: 'operation_type.name',
                    sort: true
                },
                {
                    dataField: 'status',
                    text: 'Estado del viaje',
                    path: 'status.name',
                    sort: true
                },
                {
                    dataField: 'product__name',
                    text: 'Producto',
                    path: 'product.name',
                    sort: true
                },
                {
                    dataField: 'carrier',
                    text: 'Empresa Transportista',
                    path: 'carrier',
                    sort: true
                },
                {
                    dataField: 'driver_name',
                    text: 'Chofer',
                    path: 'driver_name',
                    sort: true
                },
                {
                    dataField: 'truck_plate',
                    text: 'Patente Chasis',
                    path: 'truck_plate',
                    sort: true
                },
                {
                    dataField: 'trailer_plate',
                    text: 'Patente Acoplado',
                    path: 'trailer_plate',
                    sort: true
                },
                {
                    dataField: 'estimated_load_date',
                    text: 'Fecha Estimada C/D',
                    path: 'estimated_load_date',
                    sort: true,
                    formatter: formatters.dateFormat
                }
            ];
        }

        if(helpers.isUserProvider(user)){
            return [
                {
                    dataField: 'incoterm',
                    text: 'Tipo de Viaje',
                    path: 'incoterm.name',
                    sort: true
                },
                {
                    dataField: 'status',
                    text: 'Estado del viaje',
                    path: 'status.name',
                    sort: true
                },
                {
                    dataField: 'product__name',
                    text: 'Producto',
                    path: 'product.name',
                    sort: true
                },
                {
                    style: {textAlign: 'right'},
                    dataField: 'order_volume',
                    text: 'Cantidad Prog. en Lts 15°',
                    path: 'order_volume',
                    sort: true,
                    formatter: formatters.intFormat
                },
                {
                    style: {textAlign: 'right'},
                    dataField: 'provider_load_volume',
                    text: 'Cantidad Despachada',
                    path: 'provider_load_volume',
                    sort: true,
                    isCustom: true
                },
                {
                    dataField: 'terminal__name',
                    text: 'Destino',
                    path: 'terminal.name',
                    sort: true
                },
                {
                    dataField: 'estimated_load_date',
                    text: 'Fecha Estimada de Carga',
                    path: 'estimated_load_date',
                    sort: true,
                    formatter: formatters.dateFormat
                },
                {
                    dataField: 'load_datetime',
                    text: 'Fecha de Carga en Origen',
                    path: 'load_datetime',
                    sort: true,
                    formatter: formatters.datetimeFormat
                },
                {
                    dataField: 'carrier',
                    text: 'Empresa Transportista',
                    path: 'carrier',
                    sort: true
                },
                {
                    dataField: 'truck_id',
                    text: 'Transporte Unidad',
                    path: 'truck_id',
                    sort: true
                },
                {
                    dataField: 'truck_plate',
                    text: 'Patente Camión',
                    path: 'truck_plate',
                    sort: true
                },
                {
                    dataField: 'trailer_plate',
                    text: 'Patente Acoplado',
                    path: 'trailer_plate',
                    sort: true
                }
            ];
        }

        // Admin, Sysadmin, Report, Programm, Island, Internal
        return [
            {
                dataField: 'incoterm',
                text: 'Tipo de Viaje',
                path: 'incoterm.name',
                sort: true
            },
            {
                dataField: 'st_number',
                text: 'Número ST',
                path: 'st_number',
                sort: true
            },
            {
                dataField: 'truck_id',
                text: 'Transporte Unidad',
                path: 'truck_id',
                sort: true
            },
            {
                dataField: 'status',
                text: 'Estado del viaje',
                path: 'status.name',
                sort: true
            },
            {
                dataField: 'provider__business_name',
                text: 'Proveedor',
                path: 'provider.business_name',
                sort: true
            },
            {
                dataField: 'product__name',
                text: 'Producto',
                path: 'product.name',
                sort: true
            },
            {
                style: {textAlign: 'right'},
                dataField: 'order_volume',
                text: 'Orden en Lts 15°',
                path: 'order_volume',
                sort: true,
                formatter: formatters.intFormat
            },
            {
                style: {textAlign: 'right'},
                dataField: 'provider_load_volume',
                text: 'Cantidad Despachada',
                path: 'provider_load_volume',
                isCustom: true,
                sort: true
            },
            {
                dataField: 'terminal__name',
                text: 'Destino',
                path: 'terminal.name',
                sort: true
            },
            {
                dataField: 'estimated_load_date',
                text: 'Fecha Estimada de Carga',
                path: 'estimated_load_date',
                sort: true,
                formatter: formatters.dateFormat
            },
            {
                dataField: 'carrier',
                text: 'Empresa Transportista',
                path: 'carrier',
                sort: true
            },
            {
                dataField: 'driver_name',
                text: 'Chofer',
                path: 'driver_name',
                sort: true
            },
            {
                dataField: 'truck_plate',
                text: 'Patente Chasis',
                path: 'truck_plate',
                sort: true
            },
            {
                dataField: 'trailer_plate',
                text: 'Patente Acoplado',
                path: 'trailer_plate',
                sort: true
            },
            {
                dataField: 'load_datetime',
                text: 'Fecha de Carga en Origen',
                path: 'load_datetime',
                sort: true,
                formatter: formatters.datetimeFormat
            }
        ];

    },
    getCustomCellValue: (trip, field, value) => {
        if(!value) return '-';

        if(field === 'provider_load_volume'){
            let {product} = trip;
            if(product){
                value = `${formatters.intFormat(value)} ${_.capitalize(product.origin_unit_of_measure)}.${product.origin_density ? ` a ${formatters.floatFormat(product.origin_density)}º` : ""}`;
            }
        }

        return value
    },
    getMeterReportColumns: () => {
        return [
            {
                dataField: 'trip',
                text: 'Viaje',
                path: 'trip'
            },
            {
                dataField: 'provider_trip_receipt',
                text: 'Remito Proveedor',
                path: 'provider_trip_receipt'
            },
            {
                dataField: 'entry_weight',
                text: 'Peso entrada',
                path: 'entry_weight'
            },
            {
                dataField: 'exit_weight',
                text: 'Peso salida',
                path: 'exit_weight'
            },
            {
                dataField: 'product',
                text: 'Producto',
                path: 'product.name'
            },
            {
                dataField: 'provider_load_volume',
                text: 'Despacho proveedor',
                path: 'provider_load_volume',
                custom: true
            },
            {
                dataField: 'unload_started_at',
                text: 'Fecha de descarga',
                path: 'unload_started_at'
            },
            {
                dataField: 'initial_totalizer',
                text: 'Meter inicial',
                path: 'initial_totalizer'
            },
            {
                dataField: 'final_totalizer',
                text: 'Meter final',
                path: 'final_totalizer'
            },
            {
                dataField: 'unloaded_volume',
                text: 'Volumen descargado',
                path: 'unloaded_volume',
                custom: true
            },
            {
                dataField: 'review_reason',
                text: 'Motivo revisión',
                path: 'review_reason'
            },
            {
                dataField: 'audit_reason',
                text: 'Motivo auditoría',
                path: 'audit_details.audit_reason'
            },
            {
                dataField: 'audited_initial_totalizer',
                text: 'Meter inicial',
                path: 'audit_details.audited_initial_totalizer'
            },
            {
                dataField: 'audit_user',
                text: 'Operador',
                path: 'audit_details.audit_user'
            },
            {
                dataField: 'audit_observations',
                text: 'Observaciones',
                path: 'audit_details.audit_observations'
            }
        ];
    }
};

export default helpers;


// WEBPACK FOOTER //
// ./src/utils/helpers.js